import { IApplicationState } from '../../types/redux';

export function getSellers(state: IApplicationState) {
  const {
    newbuildingInfo: { sellers },
  } = state;

  if (sellers) {
    return sellers;
  }

  return [];
}
